module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("lyb5Y"))).then(() => parcelRequire('2L7l6'));